import { FullScreenController } from './embed.v4.fullscreen';
import { GuideData } from './embed.v4.data';
import { ConclusionController } from './embed.v4.conclusion';
import { GuideController } from './embed.v4.guide';
import { IntroController } from './embed.v4.intro';
import { PrepareEmbed } from './embed.v4.prepare';
import { StepController } from './embed.v4.step';
import { Zoom } from './embed.v4.zoom';

new GuideController(
   GuideData,
   IntroController(GuideData, FullScreenController, PrepareEmbed),
   StepController(FullScreenController, PrepareEmbed, Zoom),
   FullScreenController,
   ConclusionController(FullScreenController, PrepareEmbed)
);

window.onload = function () {
   setTimeout(() => {
      let el = document.getElementById('guideContainer'),
         height = el.scrollHeight;
      window.parent.postMessage(['setHeight', height], '*');
   }, 1000);
};
